import { createAsyncThunk } from '@reduxjs/toolkit';
import type {
  ContratoTenant,
  EditarContratoFormData,
  EncerrarContratoData,
  SuspenderProdutoData,
  VincularProdutoFormData,
} from '../../types/contratosTenant';
import { contratosTenantService } from './services';

export const fetchContratosByTenant = createAsyncThunk<ContratoTenant[], string>(
  'contratosTenant/fetchByTenant',
  async (tenantId, { rejectWithValue }) => {
    try {
      return await contratosTenantService.fetchByTenantId(tenantId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchContratoById = createAsyncThunk<ContratoTenant, string>(
  'contratosTenant/fetchById',
  async (contratoId, { rejectWithValue }) => {
    try {
      return await contratosTenantService.getById(contratoId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const vincularProduto = createAsyncThunk<
  ContratoTenant,
  { tenantId: string; data: VincularProdutoFormData }
>('contratosTenant/vincularProduto', async ({ tenantId, data }, { rejectWithValue }) => {
  try {
    return await contratosTenantService.vincularProduto(tenantId, data);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const editarContrato = createAsyncThunk<
  ContratoTenant,
  { contratoId: string; data: EditarContratoFormData }
>('contratosTenant/editarContrato', async ({ contratoId, data }, { rejectWithValue }) => {
  try {
    return await contratosTenantService.editarContrato(contratoId, data);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const suspenderContrato = createAsyncThunk<ContratoTenant, SuspenderProdutoData>(
  'contratosTenant/suspenderContrato',
  async (dados, { rejectWithValue }) => {
    try {
      return await contratosTenantService.suspenderContrato(dados);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const reativarContrato = createAsyncThunk<ContratoTenant, string>(
  'contratosTenant/reativarContrato',
  async (contratoId, { rejectWithValue }) => {
    try {
      return await contratosTenantService.reativarContrato(contratoId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const encerrarContrato = createAsyncThunk<ContratoTenant, EncerrarContratoData>(
  'contratosTenant/encerrarContrato',
  async (dados, { rejectWithValue }) => {
    try {
      return await contratosTenantService.encerrarContrato(dados);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const excluirContrato = createAsyncThunk<string, string>(
  'contratosTenant/excluirContrato',
  async (contratoId, { rejectWithValue }) => {
    try {
      return await contratosTenantService.excluirContrato(contratoId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
